import React from 'react';
import Select from 'react-select';
import { useAppStore } from 'src/context/AppContext';
import { SelectResolution } from 'src/types/ViewModel/SelectResolution';
import resolutionUtils from 'src/utils/resolutionUtils';

type Props = {
    onChange: (ev: any) => void;
};

const SelectResolutionComponent: React.FC<Props> = (props) => {
    const { selectedResolution, resolutionList } = useAppStore();
    const { getResolution } = resolutionUtils();

    const mappedOptions = (): SelectResolution[] => {
        const vList: SelectResolution[] = resolutionList.map((v) => {
            return new SelectResolution(v, getResolution(v));
        });
        return vList.sort((a, b) => a.label.localeCompare(b.label));
    };

    const mappedSelectedResolution = (): SelectResolution | null => {
        if (selectedResolution) {
            return new SelectResolution(selectedResolution, getResolution(selectedResolution));
        }
        return null;
    };

    const styles = {
        control: (css) => ({ ...css, display: 'inline-flex', width: '200px' }),
    };

    return (
        <Select
            className="select-container"
            value={mappedSelectedResolution()}
            options={mappedOptions()}
            onChange={props.onChange}
            styles={styles}
            isSearchable={true}
        />
    );
};

export default SelectResolutionComponent;
